import { Routes } from '@angular/router';
import { AuthGuard } from '../shared/guards/auth.guard';
import { AuthenticationLayoutComponent } from './authentication-layout/authentication-layout.component';
import { LayoutComponent } from './layout/layout.component';
import { UserRoleGuard } from '../shared/guards/user-role.guard';
import { CustomerRoleGuard } from '../shared/guards/customer-role.guard';
import { AdminRoleGuard } from '../shared/guards/admin-role.guard';
import { BlankLayoutComponent } from './blank-layout/blank-layout.component';
import { CompanyTermsViewComponent } from '../terms/components/t-and-c/company-terms-view.component.';
// import { TrackerRoutingDetailsComponent } from '../tracker/components/tracker-routing-details/tracker-routing-details.component';
import { TrackingRoutingDetailsComponent } from '../tracking/components/tracking-routing-details/tracking-routing-details.component';
import { TrackerListComponent } from '../tracker/components/tracker-list/tracker-list.component';

export const routes: Routes = [
  // Routing for terms and conditions
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/tracker',
    //redirectTo: '/consolidation',
  },
  {
    path: 'privacypolicy',
    pathMatch: 'full',
    redirectTo: '/privacypolicy',
  },
  {
    path: '',
    component: AuthenticationLayoutComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () => import('../authentication/authentication.routes').then(m => m.authRoutes)
      },
    ],
  },
  {
    path: '',
    component: BlankLayoutComponent,
    children: [
      {
        path: 'privacypolicy',
        loadChildren: () => import('../privacypolicy/privacypolicy-routes').then(m => m.privacyPolicyRoutes)
      }
    ],
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        canActivate: [AuthGuard, UserRoleGuard],
        path: 'processing',
        loadChildren: () => import('../processing/processing-routes').then(m => m.porcessingRoutes)
      },
      {
        canActivate: [AuthGuard, UserRoleGuard],
        path: 'consolidation',
        loadChildren: () => import('../consolidation/consolidation-routes').then(m => m.consolidationRoutes)
     },
        // {
        //   path: '',
        //   component: TrackerListComponent,
        //   children: [
        //     {
        //       path: 'tracker',
        //       loadChildren: () => import('../tracker/tracker.routes').then(m => m.trackerRoutes)
        //     }
        //   ]
        // },
      {
        path: 'tracker',
        loadChildren: () => import('../tracker/tracker.routes').then(m => m.trackerRoutes)
      },
      {
        canActivate: [AuthGuard, CustomerRoleGuard],
        path: 'tracking',
        loadChildren: () => import('../tracking/tracking-routing.route').then(m => m.trackingRoutesRoutes)
      },
      {
        path: 'terms/:companyCode', component: CompanyTermsViewComponent
      },
      {
        canActivate: [AuthGuard, AdminRoleGuard],
        path: 'administration',
        loadChildren: () => import('../administration/administration-routes').then(m => m.administrationRoutes)
      },
      {
        canActivate: [AuthGuard, AdminRoleGuard],
        path: 'admindashboard',
        loadChildren: () => import('../admindashboard/admindashboard-routes').then(m => m.admindashboardRoutes)
      },
      {
        canActivate: [AuthGuard],
        path: 'contactus',
        loadChildren: () => import('../contact/contactus.routes').then(m => m.contactUsRoutes)
      },
      {
        // canActivate: [AuthGuard, AdminRoleGuard],
        path: 'contactusguest',
        loadChildren: () => import('../contact/contactus.routes').then(m => m.contactUsRoutes)
      },
      {
        path: '',
        pathMatch: 'full',
        component: TrackerListComponent,
        children: [
          {
            path: 'tracker',
            loadChildren: () => import('../tracker/tracker.routes').then(m => m.trackerRoutes)
          }
        ]
      },
      {
        canActivate: [AuthGuard, UserRoleGuard],
        path: 'quoterequest',
        loadChildren: () => import('../quoterequest/quoterequest-routing.routes').then(m => m.quoteRequestRoutes)
      },
      {
        path: 'quoterequestguest',
        loadChildren: () => import('../quoterequest/quoterequest-routing.routes').then(m => m.quoteRequestRoutes)
      },
      {
        canActivate: [AuthGuard, UserRoleGuard],
        path: 'changepassword',
        loadChildren: () => import('../changepassword/changepassword-routes').then(m => m.chnagePasswordRoutes)
      },
      {
        canActivate: [AuthGuard, UserRoleGuard],
        path: 'terms',
        loadChildren: () => import('../terms/components/view-terms-and-conditions-routes').then(m => m.termsAndConditionRoutes)
      },
      {
        path: 'termsguest',
        loadChildren: () => import('../terms/components/view-terms-and-conditions-routes').then(m => m.termsAndConditionRoutes)
      }
    ],
  },
  {
    path: '**',
    redirectTo: '/tracker',
    //redirectTo: '/consolidation', 
  }
];